import type { RealtimePostgresChangesPayload } from '@supabase/supabase-js'

export async function handleRealtimeUserProfileUpdate(payload: RealtimePostgresChangesPayload<any>) {
  console.log("Realtime user profile update received:", payload)
  const { eventType, new: newRecord } = payload
  const supabaseUserData = useSupabaseUserData()
  
  if (eventType === 'UPDATE' && newRecord) {
    supabaseUserData.value = newRecord
  }
} 